<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @open="open"
             @closed="closed"
             width="1300px">
    <div style="margin: 20px 70px 0 40px">
      <div style="margin-bottom: 20px">
        <el-input prefix-icon="el-icon-search" clearable v-model="filter.searchText" style="width: 260px"
                  placeholder="商品名称、编号"></el-input>
        <label style="margin-left: 12px; margin-right: 8px">供应商</label>
        <remote-select v-model="filter.supplierCode" class-name="SUPPLIER" using-code select-all></remote-select>
      </div>
      <el-table :data="goodsList" class="table-border" header-cell-class-name="table-head" max-height="600">
        <el-table-column>
          <template #header>
            <el-checkbox v-model="selected" @change="selectAll"></el-checkbox>
          </template>
          <template #default="{ row }">
            <el-checkbox v-model="row.selected" @input="selectChange(row)"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column label="商品名称" prop="name"></el-table-column>
        <el-table-column label="商品编号" prop="code"></el-table-column>
        <el-table-column label="单位" prop="unit"></el-table-column>
        <el-table-column label="单位2" prop="unit2">
          <template #default="{ row }">
            <div v-if="!row.selected"></div>
            <el-input v-else v-model.number="row.unit2"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="单位2/单位" prop="unit_ratio">
          <template #default="{ row }">
            <div v-if="!row.selected"></div>
            <el-input v-else v-model.number="row.unitRatio"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="num" width="100">
          <template #default="{ row }">
            <div v-if="!row.selected"></div>
            <el-input-number v-else v-model="row.num" style="width: 90px"
                             controls-position="right"
                             :step="0.001"
                             :min="0"
                             step-strictly>
            </el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="生产日期" prop="productionDate" width="140">
          <template #default="{ row }">
            <div v-if="!row.selected"></div>
            <el-date-picker v-else style="max-width: 130px;"
                            v-model="row.productionDate"
                            type="date"
                            format="yyyy-MM-dd"
                            placeholder="选择日期">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="保质期天数" prop="expireDays">
          <template #default="{ row }">
            <div v-if="!row.selected"></div>
            <el-input v-else v-model.number="row.expireDays"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="上限" prop="upperBound" width="100">
          <template #default="{ row }">
            <div v-if="!row.selected"></div>
            <el-input-number v-else v-model="row.upperBound" style="width: 90px"
                             controls-position="right"
                             :step="0.001"
                             :min="0"
                             step-strictly>
            </el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="下限" prop="lowerBound" width="100">
          <template #default="{ row }">
            <div v-if="!row.selected"></div>
            <el-input-number v-else v-model="row.lowerBound" style="width: 90px"
                             controls-position="right"
                             :step="0.001"
                             :min="0"
                             step-strictly>
            </el-input-number>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <template #footer>
      <el-button type="primary" @click="confirm()">确 认</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

import RemoteSelect from '@/components/selector/RemoteSelect'

export default {
  name: 'SelectGoodsDialog',
  components: { RemoteSelect },
  props: {
    inbound: {
      type: Object,
      required: true
    },
    readOnly: Boolean
  },
  data () {
    return {
      selected: false,
      filter: {
        searchText: null,
        supplierCode: null
      }
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'SUPPLIER')
    this.$store.dispatch('goods/all').finally(() => {
    })
  },
  methods: {
    open () {
    },
    closed () {
    },
    confirm () {
      for (const item of this.goodsList) {
        if (!item.selected) continue
        if (item.num === 0) {
          this.$alert(`请填写 ${item.name} 的数量`)
          return
        }
        if (!item.productionDate) {
          this.$alert(`请填写 ${item.name} 的生产日期`)
          return
        }
        if (typeof item.productionDate === 'object') {
          item.productionDate = item.productionDate.format('yyyy-MM-dd')
        }
        if (!item.expireDays) {
          this.$alert(`请填写 ${item.name} 的有效日期天数`)
          return
        }
      }
      this.$emit('update', this.goodsList.filter(item => item.selected))
      this.hide()
    },
    cancel () {
      this.hide()
    },
    hide () {
      this.$emit('update:visible', false)
    },
    selectChange (row) {
      if (row.selected) {
        if (!row.num) {
          this.$set(row, 'num', 0)
          this.$set(row, 'expireDays', 0)
          this.$set(row, 'upperBound', 0)
          this.$set(row, 'lowerBound', 0)
          this.$set(row, 'unit2', null)
          this.$set(row, 'unitRatio', 1)
        }
      }
    },
    selectAll () {
      for (const item of this.goodsList) {
        item.selected = this.selected
      }
    }
  },
  computed: {
    isNew () {
      return !this.inbound.id
    },
    controlReadOnly () {
      return !this.isNew && this.readOnly
    },
    title () {
      if (this.isNew) return '新增入库'
      return this.readOnly ? '入库详细信息' : '编辑入库'
    },
    goodsList () {
      const goodsIdMap = {}
      for (const goods of this.inbound.goodsList) {
        goodsIdMap[goods.id] = goods
      }
      let list = this.$_.cloneDeep(this.$store.state.goods.goodsList)
      for (const goods of list) {
        const selectedGoods = goodsIdMap[goods.id]
        if (selectedGoods) {
          this.$set(goods, 'selected', true)
          this.$set(goods, 'num', selectedGoods.num)
          this.$set(goods, 'productionDate', selectedGoods.productionDate)
          this.$set(goods, 'expireDays', selectedGoods.expireDays)
          this.$set(goods, 'upperBound', selectedGoods.upperBound)
          this.$set(goods, 'lowerBound', selectedGoods.lowerBound)
          this.$set(goods, 'unit2', selectedGoods.unit2)
          this.$set(goods, 'unitRatio', selectedGoods.unitRatio)
        } else {
          this.$set(goods, 'selected', false)
        }
      }

      if (this.filter.searchText) {
        list = list.filter(item =>
          item.name.indexOf(this.filter.searchText) >= 0 ||
          item.code.indexOf(this.filter.searchText) >= 0
        )
      }

      if (this.filter.supplierCode && this.filter.supplierCode !== -1) {
        list = list.filter(item => item.supplierCode === this.filter.supplierCode)
      }

      return list
    }
  }
}
</script>

<style scoped>

</style>
